// AUTO-GENERATED by scripts/generate-mcc-mnc-data.mjs — DO NOT EDIT BY HAND.
// Source: https://github.com/musalbas/mcc-mnc-table (daily mirror of mcc-mnc.com)
// Re-run `node scripts/generate-mcc-mnc-data.mjs` to refresh.
//
// Compact `${mcc}${mnc}` -> operator-name map covering every public MCC/MNC
// allocation. Consumed by plmnTable.ts as the last-resort fallback after the
// curated overrides. 2070 entries.
/* eslint-disable */
export const MCC_MNC_OPERATORS = {
    '20201': "Cosmote",
    '20202': "Cosmote",
    '20203': "OTE",
    '20204': "OSE",
    '20205': "Vodafone",
    '20207': "AMD Telecom",
    '20209': "Wind",
    '20210': "Wind",
    '20212': "Yuboto",
    '20214': "CyTa Mobile",
    '20215': "BWS",
    '20216': "Inter Telecom",
    '202299': "AMD Telecom",
    '202999': "Fix Line",
    '20400': "Intovoice",
    '20402': "T-Mobile",
    '20403': "Voiceworks Mobile",
    '20404': "Vodafone",
    '20405': "ElephantTalk",
    '20406': "Vectone Mobile",
    '20407': "Move / Teleena",
    '20408': "KPN",
    '20409': "Lycamobile",
    '20410': "KPN",
    '20412': "KPN",
    '20414': "6GMOBILE BV",
    '20415': "Ziggo",
    '20416': "T-Mobile",
    '20417': "Intercity Mobile Communications BV",
    '20418': "Ziggo Services",
    '20420': "T-Mobile",
    '20421': "ProRail",
    '20423': "KORE",
    '20424': "Private Mobility",
    '20426': "SpeakUp",
    '20427': "L-mobi",
    '20428': "Lancelot",
    '20429': "Tismi",
    '204299': "88 mobile",
    '20430': "ASPIDER Solutions",
    '20433': "Truphone",
    '20463': "MessageBird",
    '20468': "Unify Mobile",
    '20469': "KPN",
    '20498': "Lancelot",
    '204999': "Fix Line",
    '20600': "Proximus",
    '20601': "Proximus",
    '20602': "Infrabel",
    '20604': "Proximus",
    '20605': "Base",
    '20606': "Lycamobile",
    '20607': "Vectone Mobile",
    '20608': "VOOmobile",
    '20610': "Mobistar / Orange",
    '20620': "Base",
    '20623': "Dust Mobile",
    '20625': "Dense Air",
    '20628': "BICS",
    '206299': "FEBO",
    '20630': "Mobile Vikings",
    '20633': "Ericsson",
    '20634': "onoff",
    '20699': "Lancelot",
    '206999': "Fix Line",
    '20800': "Tel/Te",
    '20801': "Orange",
    '20802': "Orange",
    '20803': "MobiquiThings",
    '20804': "Axialys",
    '20805': "GlobalStar",
    '20806': "GlobalStar",
    '20807': "GlobalStar",
    '20808': "SFR",
    '20809': "SFR",
    '20810': "SFR",
    '20811': "SFR",
    '20812': "Truphone",
    '20813': "SFR",
    '20814': "Free Mobile",
    '20815': "Free Mobile",
    '20816': "Free Mobile",
    '20817': "Legos",
    '20820': "Bouygues Telecom",
    '20821': "Bouygues Telecom",
    '20822': "Transatel",
    '20823': "Hub One",
    '20824': "MobiquiThings",
    '20825': "Lycamobile",
    '20826': "NRJ",
    '20827': "Coriolis",
    '20828': "Airmob",
    '20829': "Orange",
    '208299': "Add-On Multimedia",
    '20830': "Syma Mobile",
    '20831': "Vectone Mobile",
    '20832': "Orange",
    '20834': "Cellhire",
    '20835': "Free Mobile",
    '20836': "Free Mobile",
    '20837': "IP Directions",
    '20838': "Lebara",
    '20839': "Networth Telecom",
    '20888': "Bouygues Telecom",
    '20889': "Hub One",
    '20891': "Orange",
    '20892': "IP Directions",
    '20894': "Halys",
    '208999': "Fix Line",
    '21201': "Monaco Telecom",
    '21210': "Monaco Telecom",
    '21303': "Andorra Telecom / Mobiland",
    '21401': "Vodafone",
    '21402': "Alta Tecnologia en Comunicacions",
    '21403': "Orange",
    '21404': "Yoigo",
    '21405': "Movistar",
    '21406': "Vodafone",
    '21407': "Movistar",
    '21408': "Euskaltel Movil",
    '21409': "Orange",
    '21410': "Zinnia",
    '21411': "Orange",
    '21412': "Venus Movil",
    '21414': "Avatel Movil",
    '21415': "BT Espana  SAU",
    '21416': "mobil R",
    '21417': "mobil R",
    '21418': "Cableuropa SAU (ONO)",
    '21419': "Simyo",
    '21420': "fonYou Wireless SL",
    '21421': "Jazz Telecom SAU",
    '21422': "Digi.Mobil",
    '21423': "Yoigo",
    '21425': "Lycamobile",
    '21426': "Lleida",
    '21427': "Truphone",
    '21429': "Yoigo",
    '214299': "ACN",
    '21432': "ION Mobile",
    '21433': "Yoigo",
    '21434': "ION MOBILE",
    '21435': "SUMA movil",
    '21436': "Alai",
    '21437': "Vodafone",
    '21438': "Movistar",
    '214999': "Fix Line",
    '21601': "Telenor",
    '21602': "MVM NET",
    '21603': "Digi",
    '216299': "Antenna",
    '21630': "Telekom",
    '21670': "Vodafone",
    '21671': "UPC Magyarorszag Kft.",
    '216999': "Fix line",
    '21803': "Eronet",
    '21805': "m:tel",
    '21890': "BH Mobile",
    '21901': "T-Mobile",
    '21902': "Telemach / Tele2",
    '21910': "A1 / VIP",
    '21912': "TELE FOCUS",
    '219999': "Fix Line",
    '22001': "Telenor",
    '22002': "Telenor",
    '22003': "MTS",
    '22005': "VIP",
    '22011': "Globaltel",
    '22020': "VIP",
    '22101': "Vala",
    '22102': "IPKO",
    '22103': "MTS",
    '22106': "Dardafon.Net LLC",
    '22107': "D3 mobile",
    '221299': "MTS",
    '22200': "Premium Numbers",
    '22201': "TIM",
    '22202': "Elsacom",
    '22206': "Vodafone",
    '22207': "Noverca Italia",
    '22208': "Fastweb",
    '22210': "Vodafone",
    '222299': "A-Tono",
    '22230': "RFI",
    '22233': "Poste Mobile",
    '22234': "BT mobile",
    '22235': "Lycamobile",
    '22236': "Digi",
    '22237': "WindTre / Hi3G",
    '22239': "SMS.it / LINK Mobility",
    '22240': "Agile Telecom",
    '22242': "Enel",
    '22243': "Telecom Italia Mobile",
    '22244': "Mundio",
    '22248': "Telecom Italia Mobile",
    '22249': "Vianova Mobile",
    '22250': "Iliad",
    '22251': "ho.",
    '22253': "CoopVoce",
    '22254': "Plintron",
    '22256': "spusu",
    '22258': "rdcom",
    '22277': "IPSE 2000",
    '22288': "WindTre / WIND",
    '22299': "WindTre / Hi3G",
    '222999': "Fix Line",
    '22601': "Vodafone",
    '22602': "Romtelecom SA",
    '22603': "Telekom",
    '22604': "Telekom Romania",
    '22605': "Digi Mobil",
    '22606': "Telekom Romania",
    '22610': "Orange",
    '22611': "Enigma Systems",
    '22616': "Lycamobile",
    '226299': "Iristel",
    '22801': "Swisscom",
    '22802': "Sunrise",
    '22803': "Salt Mobile",
    '22805': "Comfone",
    '22806': "SBB",
    '22807': "Sunrise",
    '22808': "Sunrise",
    '22809': "Comfone",
    '22812': "Sunrise",
    '22851': "relario",
    '22852': "Mundio Mobile AG",
    '22853': "Sunrise",
    '22854': "Lycamobile",
    '22858': "Beeone",
    '22859': "Vectone Mobile",
    '22860': "Sunrise",
    '22862': "Telecom26",
    '22865': "Nexphone",
    '22866': "Inovia",
    '22869': "MTEL",
    '22870': "Tismi",
    '228999': "Fix Line",
    '23001': "T-Mobile",
    '23002': "O2",
    '23003': "Vodafone",
    '23004': "Nordic Telecom",
    '23005': "PODA",
    '23007': "T-Mobile",
    '23008': "Compatel",
    '23009': "Uniphone",
    '230299': "+4U Mobile",
    '23098': "SZDC",
    '23099': "Vodafone",
    '230999': "Fix Line",
    '23101': "Orange",
    '23102': "Telekom",
    '23103': "Swan / 4ka",
    '23104': "Telekom",
    '23105': "Orange",
    '23106': "O2",
    '23107': "Orange",
    '23108': "Uniphone",
    '23115': "Orange",
    '231299': "Vonage",
    '23150': "Telekom",
    '23199': "ZSR",
    '23201': "A1 Telekom",
    '23202': "A1 Telekom",
    '23203': "T-Mobile / Magenta",
    '23204': "T-Mobile / Magenta",
    '23205': "Hutchinson Drei",
    '23206': "Hutchison Drei / 3",
    '23207': "T-Mobile / Magenta",
    '23208': "A1 Telekom",
    '23209': "A1 Telekom",
    '23210': "Hutchinson Drei",
    '23211': "A1 Telekom",
    '23212': "A1 Telekom",
    '23213': "T-Mobile / Magenta",
    '23214': "Hutchinson Drei",
    '23215': "T-Mobile / Magenta",
    '23216': "Hutchinson Drei",
    '23217': "Mass Response Service",
    '23218': "smartspace",
    '23219': "Hutchinson Drei",
    '23220': "Mtel",
    '23222': "Plintron",
    '23223': "T-Mobile / Magenta",
    '23224': "Smartel Services",
    '23225': "Holding Graz",
    '23226': "LIWEST Mobil",
    '23227': "Tismi",
    '232299': "ArgoNET",
    '23291': "OBB Infrastruktur",
    '232999': "Fix Line",
    '23400': "BT Group",
    '23401': "Vectone Mobile",
    '23402': "O2",
    '23403': "Jersey Airtel",
    '23404': "FMS Solutions",
    '23407': "Vodafone",
    '23408': "BT OnePhone",
    '23409': "Tismi",
    '23410': "O2",
    '23411': "O2",
    '23412': "Network Rail",
    '23413': "Network Rail",
    '23414': "LINK Mobility",
    '23415': "Vodafone",
    '23416': "Talk Talk",
    '23417': "FlexTel",
    '23418': "Cloud9",
    '23419': "TeleWare",
    '23420': "3",
    '23422': "Telesign Mobile",
    '23423': "Icron Network",
    '23424': "Greenfone",
    '23425': "Truphone",
    '23426': "Lycamobile",
    '23427': "Tata Communications Ltd",
    '23428': "Marathon Telecom",
    '23429': "aql",
    '23430': "T-Mobile",
    '23431': "T-Mobile",
    '23432': "T-Mobile",
    '23433': "Orange",
    '23434': "Orange",
    '23435': "JSC Ingenicum",
    '23436': "Sure Isle of Man",
    '23437': "Synectiv",
    '23438': "Virgin Mobile",
    '23439': "Gamma Mobile",
    '23440': "spusu",
    '23450': "JT Mobile",
    '23451': "now broadband",
    '23455': "Sure Guernsey",
    '23456': "NCSC",
    '23457': "Sky",
    '23458': "Manx Telecom Mobile",
    '23471': "Home Office",
    '23472': "Hanhaa Mobile",
    '23474': "Pareteum",
    '23475': "Mass Response Service GmbH",
    '23476': "BT Group",
    '23477': "Vodafone",
    '23478': "Airwave",
    '23489': "Vodafone",
    '23491': "Vodafone",
    '23492': "Vodafone",
    '23494': "3",
    '23495': "Network Rail",
    '23499': "08Direct",
    '234998': "Virgin Mobile",
    '234999': "Fix Line",
    '23502': "Everyth. Ev.wh.",
    '23801': "TDC",
    '23802': "Telenor",
    '23803': "Syniverse Technologies",
    '23804': "Nexcon.io",
    '23806': "3",
    '23807': "Mundio Mobile",
    '23808': "Voxbone / Bandwidth",
    '23810': "TDC",
    '23812': "Lycamobile",
    '23813': "Compatel",
    '23814': "Monty Mobile",
    '23815': "Net 1",
    '23816': "Tismi",
    '23817': "Gotanet",
    '23820': "Telia",
    '23823': "Banedanmark",
    '23825': "Viahub",
    '23828': "LINK Mobility",
    '23830': "Pareteum",
    '23842': "Greenwave",
    '23873': "Onomondo",
    '23877': "Telenor",
    '23888': "Cobira",
    '23896': "Telia",
    '238999': "Fix Line",
    '24001': "Telia",
    '24002': "3",
    '24003': "Net 1",
    '24004': "Telenor",
    '24005': "Tele2",
    '24006': "Telenor",
    '24007': "Tele2",
    '24008': "Telenor",
    '24009': "Com4",
    '24010': "Spring Mobil AB",
    '24011': "Com Hem",
    '24012': "Lycamobile",
    '24013': "A3",
    '24014': "Tele2",
    '24015': "Sierra Wireless Sweden AB",
    '24016': "42 Telecom AB",
    '24017': "Gotanet",
    '24018': "Messit / Minicall",
    '24019': "Vectone Mobile",
    '24020': "Sierra Wireless",
    '24021': "Trafikverket",
    '24022': "EUtel",
    '24023': "Infobip",
    '24024': "Telenor",
    '24025': "Monty Mobile",
    '24026': "Twilio",
    '24027': "Globetouch",
    '24028': "LINK Mobility",
    '24029': "MI Carrier Services",
    '24030': "NextGen Mobile Ltd (CardBoardFish)",
    '24031': "Rebtel",
    '24032': "Compatel",
    '24033': "Mobile Arts",
    '24035': "42 Telecom",
    '24036': "interactive digital media / IDM",
    '24037': "Sinch",
    '24038': "Voxbone / Bandwidth",
    '24039': "Primlight",
    '24040': "Netmore",
    '24042': "Telenor Connexion",
    '24043': "MobiWeb",
    '24044': "Telenabler",
    '24045': "Spirius",
    '24046': "Viahub",
    '24047': "Viatel",
    '24048': "Tismi",
    '24063': "Fink Telecom",
    '240999': "Fix Line",
    '24201': "Telenor",
    '242017': "Ventelo AS",
    '24202': "Telia / NetCom",
    '24203': "Teletopia",
    '24204': "Tele2",
    '24205': "Altibox Mobil",
    '24206': "ICE",
    '24207': "Ventelo AS",
    '24208': "TDC Mobil A/S",
    '24209': "Com4",
    '24210': "Nkom",
    '24212': "Telenor",
    '24214': "ICE",
    '24215': "eRate",
    '24216': "Iristel",
    '24220': "BANE NOR",
    '24221': "BANE NOR",
    '24222': "Altibox Mobil",
    '24223': "Lycamobile",
    '242299': "bigblu",
    '242999': "Fix Line",
    '24403': "DNA",
    '24404': "DNA",
    '24405': "Elisa",
    '24406': "Elisa",
    '24407': "NSN",
    '24408': "NSN",
    '24409': "NSN",
    '24410': "TDC Oy Finland",
    '24411': "Viahub",
    '24412': "DNA",
    '24413': "DNA",
    '24414': "Alcom",
    '24415': "Telit",
    '24421': "Elisa",
    '24424': "Nord Connect",
    '24426': "Compatel",
    '244299': "Benemen",
    '24432': "Voxbone / Bandwidth",
    '24433': "VIRVE",
    '24435': "Ukko Mobile",
    '24436': "Telia",
    '24437': "Tismi",
    '24438': "NSN",
    '24439': "NSN",
    '24440': "NSN",
    '24441': "NSN",
    '24442': "Viahub",
    '24443': "Telavox",
    '24445': "VIRVE",
    '24446': "VIRVE",
    '24447': "VIRVE",
    '24482': "interactive digital media / IDM",
    '24491': "Telia",
    '24601': "Telia",
    '24602': "Bite",
    '24603': "Tele2",
    '24605': "LTG",
    '24606': "Mediafon",
    '246299': "SkyCall",
    '24701': "LMT",
    '24702': "Tele2",
    '24703': "TRIATEL",
    '24704': "Tet",
    '24705': "Bite",
    '24706': "SIA Rigatta",
    '24707': "SIA Master Telecom",
    '24708': "VENTA Mobile",
    '24709': "XOmobile",
    '24710': "LMT",
    '247299': "Premium Numbers",
    '24801': "Telia",
    '24802': "Elisa",
    '24803': "Tele2",
    '24804': "TravelSim",
    '24813': "Telia",
    '25001': "MTS",
    '25002': "Megafon",
    '25003': "NCC",
    '25004': "Sibchallenge",
    '25005': "Tele2/ECC/Volgogr.",
    '25007': "ZAO SMARTS",
    '25009': "Skylink",
    '25010': "DTC/Don Telecom",
    '25011': "Yota",
    '25012': "Tele2",
    '25013': "Kuban GSM",
    '25015': "ZAO SMARTS",
    '25016': "NTC",
    '25017': "UralTel",
    '25019': "OJSC Altaysvyaz",
    '25020': "Tele2",
    '25028': "BeeLine/VimpelCom",
    '250299': "A-Mobile",
    '25032': "Win Mobile",
    '25033': "SEVTELECOM",
    '25034': "Krymtelecom",
    '25035': "Motiv",
    '25039': "UralTel",
    '25042': "MTT",
    '25044': "StavTelesot",
    '25048': "Global Telecom",
    '25054': "Letai Mobile",
    '25055': "Glonass",
    '25057': "Matrix Mobile",
    '25060': "Volna Mobile",
    '25077': "Glonass",
    '25092': "Printelefone",
    '25093': "Telecom XXL",
    '25099': "Beeline",
    '250999': "Fix Line",
    '25501': "Vodafone",
    '25502': "Kyivstar",
    '25503': "Kyivstar",
    '25504': "IT",
    '25505': "Golden Telecom",
    '25506': "lifecell",
    '25507': "3Mob",
    '25521': "PEOPLEnet",
    '25539': "Golden Telecom",
    '25550': "Vodafone",
    '25567': "KyivStar",
    '25568': "Kyivstar",
    '25599': "Phoenix",
    '25701': "MDC/Velcom",
    '25702': "MTS",
    '25703': "BelCel JV",
    '25704': "life:)",
    '25901': "Orange",
    '25902': "Moldcell",
    '25903': "Unite",
    '25904': "Eventis Mobile",
    '25905': "Unite",
    '25999': "Unite",
    '26001': "Plus",
    '26002': "T-Mobile",
    '26003': "Orange",
    '26004': "Aero2",
    '26005': "Orange",
    '26006': "Play",
    '26007': "Netia",
    '26008': "e-Telko",
    '26009': "Lycamobile",
    '26010': "T-Mobile",
    '26011': "NORDISK Polska",
    '26012': "Cyfrowy Polsat",
    '26013': "Move",
    '26014': "Move",
    '26015': "Aero2",
    '26016': "Aero2",
    '26017': "Aero2",
    '26018': "AMD Telecom",
    '26019': "NetBalt",
    '26020': "Tismi",
    '26022': "Twilio",
    '26027': "Ntel Solutions",
    '260299': "3S",
    '26032': "Compatel",
    '26034': "T-Mobile",
    '26035': "PKP",
    '26036': "Mundio Mobile Sp. z o.o.",
    '26038': "CallFreedom Sp. z o.o.",
    '26039': "Voxbone / Bandwidth",
    '26041': "EZ Mobile",
    '26042': "MobiWeb",
    '26045': "Virgin Mobile",
    '26047': "SMSHIGHWAY",
    '26048': "Agile Telecom",
    '26049': "Messagebird",
    '26090': "Polska Spolka Gazownictwa",
    '26097': "Politechnika Lodzka Uczelniane",
    '26098': "Play",
    '260999': "Fix Line",
    '26201': "Telekom / T-mobile",
    '26202': "Vodafone",
    '26203': "Telefonica / E-Plus",
    '26204': "Vodafone",
    '26205': "Telefonica / E-Plus",
    '26206': "Telekom / T-mobile",
    '26207': "Telefonica / O2",
    '26208': "Telefonica / O2",
    '26209': "Vodafone",
    '26210': "DB Netz",
    '26211': "Telefonica / O2",
    '26212': "Telefonica / E-Plus",
    '26213': "Bundesamt für Ausrüstung, Informationstechnik und Nutzung der Bundeswehr",
    '26214': "Lebara",
    '26216': "Telefonica / O2",
    '26217': "Telefonica / E-Plus",
    '26220': "Telefonica / E-Plus",
    '26221': "Multiconnect",
    '26222': "sipgate",
    '26223': "1&1",
    '26224': "TelcoVillage",
    '262299': "1&1",
    '26233': "sipgate",
    '26242': "Vodafone",
    '26243': "Lycamobile",
    '26277': "Telefonica / E-Plus",
    '26278': "Telekom / T-mobile",
    '262999': "Fix Line",
    '26601': "Gibtel",
    '26606': "CTS Mobile",
    '26609': "eazi telecom",
    '266299': "GibFibreSpeed",
    '266999': "Fix Line",
    '26801': "Vodafone",
    '26803': "NOS",
    '26804': "Lycamobile",
    '26806': "MEO",
    '26807': "NOS",
    '26808': "MEO",
    '268299': "NOWO",
    '26880': "MEO",
    '26891': "Vodafone",
    '26893': "NOS",
    '268999': "Fix Line",
    '27001': "Post",
    '27005': "Luxembourg Online",
    '27010': "Blue Communications",
    '270299': "Bouygues Telecom",
    '27077': "Tango",
    '27081': "e-LUX Mobile",
    '27099': "Orange",
    '270999': "Fix Line",
    '27201': "Vodafone",
    '27202': "3",
    '27203': "Meteor / eir mobile",
    '27204': "Access Telecom Ltd.",
    '27205': "3",
    '27207': "Meteor / eir mobile",
    '27208': "Meteor / eir mobile",
    '27211': "Tesco Mobile",
    '27213': "Lycamobile",
    '27215': "Virgin Media",
    '27217': "3",
    '27401': "Siminn",
    '27402': "Vodafone",
    '27403': "Vodafone",
    '27404': "Viking Wireless",
    '27405': "Vodafone",
    '27407': "IceCell",
    '27408': "Siminn",
    '27409': "Amitelo",
    '27411': "NOVA",
    '27412': "Vodafone",
    '27416': "Tismi",
    '27431': "Siminn",
    '27601': "One / AMC",
    '27602': "Vodafone",
    '27603': "ALBtelecom Mobile / Eagle",
    '27604': "PLUS Communication Sh.a",
    '27801': "Vodafone",
    '27821': "GO Mobile",
    '27830': "GO Mobile",
    '27877': "Melita",
    '278999': "Fix Line",
    '28001': "Cytamobile-Vodafone",
    '28002': "Cytamobile-Vodafone",
    '28010': "Epic / MTN",
    '28020': "PrimeTel",
    '28022': "Cablenet / Lemontel",
    '280999': "Fix Line",
    '28201': "Geocell",
    '28202': "MagtiCom",
    '28203': "Iberiatel Ltd.",
    '28204': "Beeline",
    '28205': "Silknet",
    '28207': "GlobalCell",
    '28208': "Silknet",
    '28210': "Premium Net",
    '28211': "Mobilive",
    '28212': "Telecom 1",
    '28222': "MyPhone",
    '28301': "Beeline",
    '28304': "KT",
    '28305': "Viva-MTS",
    '28310': "Orange",
    '28401': "A1",
    '28403': "Vivacom",
    '28405': "Telenor",
    '28406': "Vivacom",
    '28411': "Bulsatcom",
    '28413': "T.com",
    '28601': "Turkcell",
    '28602': "Vodafone",
    '28603': "Avea",
    '28604': "Avea",
    '286299': "Asistan Telekom",
    '286999': "Fix Line",
    '28801': "Faroese Telecom",
    '28802': "Hey / Kall",
    '28803': "Tosa",
    '28967': "Aquafon",
    '28968': "A-Mobile",
    '28988': "A-Mobile",
    '29001': "Tele Greenland",
    '29201': "Prima",
    '292299': "TeleneT",
    '29310': "Slovenske zeleznice",
    '29320': "Compatel",
    '293299': "HOT mobil",
    '29340': "A1 / Si.mobil",
    '29341': "Mobitel",
    '29364': "T-2",
    '29370': "Telemach / Tusmobil",
    '29386': "Elektro Gorenjska",
    '293999': "Fix Line",
    '29401': "Telekom",
    '29402': "A1",
    '29403': "A1",
    '29404': "Lycamobile",
    '29411': "Mobik",
    '294299': "LATRON",
    '29475': "A1",
    '29501': "FL GSM",
    '29502': "7acht",
    '29505': "FL1",
    '29506': "CUBIC",
    '29507': "First Mobile AG",
    '29509': "EMnify",
    '295299': "Datamobile",
    '29577': "Alpmobile/Tele2",
    '29701': "Telenor",
    '29702': "Telekom / T-mobile",
    '29703': "Mtel",
    '302220': "Telus Mobility",
    '302320': "mobilicity",
    '302360': "Clearnet",
    '302361': "Clearnet",
    '302370': "FIDO (Rogers AT&T/ Microcell)",
    '302380': "DMTS Mobility",
    '302490': "WIND",
    '302500': "Videotron",
    '302610': "Bell Mobility",
    '302630': "Bell Aliant",
    '302640': "Latitude Wireless",
    '302651': "Bell Mobility",
    '302652': "BC Tel Mobility",
    '302653': "Telus Mobility",
    '302654': "Sask Tel Mobility",
    '302655': "MTS Mobility",
    '302656': "Tbay Mobility",
    '302657': "Quebectel Mobility",
    '302660': "MTS Mobility",
    '302670': "CityWest Mobility",
    '302680': "Sask Tel Mobility",
    '302701': "NB Tel Mobility",
    '302702': "MT&T Mobility",
    '302703': "New Tel Mobility",
    '302710': "Globalstar Canada",
    '302720': "Rogers AT&T Wireless",
    '302760': "Public Mobile",
    '302780': "Sask Tel Mobility",
    '30801': "Ameris",
    '310004': "Verizon Wireless",
    '310010': "Verizon Wireless",
    '310011': "Northstar",
    '310012': "Verizon Wireless",
    '310013': "Verizon Wireless",
    '310016': "Leap Wireless International Inc.",
    '310020': "Union Telephone Co.",
    '310032': "IT&E OverSeas",
    '310033': "Guam Teleph. Auth",
    '310040': "Matanuska Tel. Assn. Inc.",
    '31006': "Consolidated Telcom",
    '310070': "AT&T Wireless Inc.",
    '310090': "Edge Wireless LLC",
    '310100': "Plateau Telecommunications Inc.",
    '310120': "Sprint Spectrum",
    '310130': "North Carolina RSA 3 Cellular Tel. Co.",
    '31014': "Testing",
    '310140': "GTA Wireless",
    '310150': "AT&T Wireless Inc.",
    '310160': "T-Mobile",
    '310170': "AT&T Wireless Inc.",
    '310180': "Cingular Wireless",
    '310200': "T-Mobile",
    '310210': "T-Mobile",
    '310220': "T-Mobile",
    '310230': "T-Mobile",
    '310240': "T-Mobile",
    '310250': "T-Mobile",
    '310260': "T-Mobile",
    '310270': "T-Mobile",
    '310280': "T-Mobile",
    '310290': "NEP Cellcorp Inc.",
    '310300': "T-Mobile",
    '31031': "T-Mobile",
    '310310': "T-Mobile",
    '310320': "Smith Bagley Inc.",
    '310330': "T-Mobile",
    '31034': "Nevada Wireless LLC",
    '310340': "Westlink Communications, LLC",
    '310350': "Mohave Cellular LP",
    '310360': "Cellular Network Partnership LLC",
    '310370': "Docomo",
    '31038': "USA 3650 AT&T",
    '310380': "AT&T Wireless Inc.",
    '310390': "Yorkville Telephone Cooperative",
    '310400': "Minnesota South. Wirel. Co. / Hickory",
    '310410': "AT&T Wireless Inc.",
    '310420': "Cincinnati Bell Wireless LLC",
    '310430': "GCI Communication Corp.",
    '310440': "Dobson Cellular Systems",
    '310450': "Northeast Colorado Cellular Inc.",
    '31046': "SIMMETRY",
    '310460': "TMP Corporation",
    '310470': "Docomo",
    '310480': "Choice Phone LLC",
    '310490': "Triton PCS",
    '310500': "Public Service Cellular Inc.",
    '310510': "Airtel Wireless LLC",
    '310520': "VeriSign",
    '310530': "West Virginia Wireless",
    '310560': "AT&T Wireless Inc.",
    '310570': "MTPCS LLC",
    '310580': "PCS ONE",
    '310590': "Verizon Wireless",
    '31060': "Consolidated Telcom",
    '310600': "New-Cell Inc.",
    '310610': "Elkhart TelCo. / Epic Touch Co.",
    '310620': "Coleman County Telco /Trans TX",
    '310650': "Jasper",
    '310660': "T-Mobile",
    '310670': "Northstar",
    '310680': "AT&T Wireless Inc.",
    '310690': "Keystone Wireless LLC",
    '310700': "Cross Valliant Cellular Partnership",
    '310710': "Arctic Slope Telephone Association Cooperative Inc.",
    '310730': "United States Cellular Corp.",
    '310740': "Telemetrix Inc.",
    '310750': "East Kentucky Network LLC",
    '310760': "Panhandle Telephone Cooperative Inc.",
    '310770': "Iowa Wireless Services LLC",
    '310780': "Message Express Co. / Airlink PCS",
    '310800': "T-Mobile",
    '310830': "Caprock Cellular Ltd.",
    '310850': "Aeris Comm. Inc.",
    '310860': "Texas RSA 15B2 Limited Partnership",
    '310870': "Kaplan Telephone Company Inc.",
    '310890': "Verizon Wireless",
    '310900': "Cable & Communications Corp.",
    '310910': "Verizon Wireless",
    '310920': "Get Mobile Inc.",
    '310940': "Poka Lambro Telco Ltd.",
    '310960': "Uintah Basin Electronics Telecommunications Inc.",
    '310980': "AT&T Wireless Inc.",
    '310990': "E.N.M.R. Telephone Coop.",
    '310999': "Various Networks",
    '311010': "Missouri RSA No 5 Partnership",
    '311020': "Missouri RSA No 5 Partnership",
    '311050': "Thumb Cellular Limited Partnership",
    '311070': "Wisconsin RSA #7 Limited Partnership",
    '311110': "Verizon Wireless",
    '311120': "Choice Phone LLC",
    '311140': "Cross Wireless Telephone Co.",
    '311170': "PetroCom",
    '311220': "United States Cellular Corp.",
    '311250': "Wave Runner LLC",
    '311260': "SLO Cellular Inc / Cellular One of San Luis",
    '311270': "Verizon Wireless",
    '311271': "Verizon Wireless",
    '311272': "Verizon Wireless",
    '311273': "Verizon Wireless",
    '311274': "Verizon Wireless",
    '311275': "Verizon Wireless",
    '311276': "Verizon Wireless",
    '311277': "Verizon Wireless",
    '311278': "Verizon Wireless",
    '311279': "Verizon Wireless",
    '311280': "Verizon Wireless",
    '311281': "Verizon Wireless",
    '311282': "Verizon Wireless",
    '311283': "Verizon Wireless",
    '311284': "Verizon Wireless",
    '311285': "Verizon Wireless",
    '311286': "Verizon Wireless",
    '311287': "Verizon Wireless",
    '311288': "Verizon Wireless",
    '311289': "Verizon Wireless",
    '311300': "Nexus Communications Inc.",
    '311310': "Lamar County Cellular",
    '311311': "Farmers",
    '311330': "Michigan Wireless LLC",
    '311340': "Illinois Valley Cellular RSA 2 Partnership",
    '311350': "Sagebrush Cellular Inc.",
    '311370': "GCI Communication Corp.",
    '311390': "Verizon Wireless",
    '311410': "Iowa RSA No. 2 Limited Partnership",
    '311420': "Northwest Missouri Cellular Limited Partnership",
    '311430': "RSA 1 Limited Partnership",
    '311440': "Bluegrass Wireless LLC",
    '311460': "Fisher Wireless Services Inc.",
    '311480': "Verizon Wireless",
    '311481': "Verizon Wireless",
    '311482': "Verizon Wireless",
    '311483': "Verizon Wireless",
    '311484': "Verizon Wireless",
    '311485': "Verizon Wireless",
    '311486': "Verizon Wireless",
    '311487': "Verizon Wireless",
    '311488': "Verizon Wireless",
    '311489': "Verizon Wireless",
    '311490': "Sprint Spectrum",
    '311500': "Cambridge Telephone Company Inc.",
    '311590': "California RSA No. 3 Limited Partnership",
    '311610': "North Dakota Network Company",
    '311650': "United Wireless Communications Inc.",
    '311670': "Pine Belt Cellular, Inc.",
    '311710': "Northeast Wireless Networks LLC",
    '311800': "Bluegrass Wireless LLC",
    '311810': "Bluegrass Wireless LLC",
    '311830': "Thumb Cellular Limited Partnership",
    '311860': "Uintah Basin Electronics Telecommunications Inc.",
    '311870': "Sprint Spectrum",
    '311880': "Sprint Spectrum",
    '311920': "Missouri RSA No 5 Partnership",
    '312010': "Missouri RSA No 5 Partnership",
    '312030': "Cross Wireless Telephone Co.",
    '312040': "Custer Telephone Cooperative Inc.",
    '312090': "Allied Wireless Communications Corporation",
    '312120': "East Kentucky Network LLC",
    '312130': "East Kentucky Network LLC",
    '312160': "RSA 1 Limited Partnership",
    '312170': "Iowa RSA No. 2 Limited Partnership",
    '312180': "Keystone Wireless LLC",
    '312190': "Sprint Spectrum",
    '312220': "Missouri RSA No 5 Partnership",
    '312230': "North Dakota Network Company",
    '312270': "Cellular Network Partnership LLC",
    '312280': "Cellular Network Partnership LLC",
    '312290': "Uintah Basin Electronics Telecommunications Inc.",
    '312530': "Sprint Spectrum",
    '316010': "Sprint Spectrum",
    '316011': "Southern Communications Services Inc.",
    '33011': "Puerto Rico Telephone Company Inc. (PRTC)",
    '330110': "Puerto Rico Telephone Company Inc. (PRTC)",
    '33401': "NEXTEL",
    '334010': "NEXTEL",
    '33402': "TelCel/America Movil",
    '334020': "TelCel/America Movil",
    '33403': "Movistar/Pegaso",
    '334030': "Movistar/Pegaso",
    '33404': "AT&T/IUSACell",
    '334040': "AT&T/IUSACell",
    '33405': "AT&T/IUSACell",
    '334050': "AT&T/IUSACell",
    '334060': "SAI PCS",
    '334070': "Operadora Unefon SA de CV",
    '334080': "Operadora Unefon SA de CV",
    '33409': "NEXTEL",
    '334090': "NEXTEL",
    '33450': "AT&T/IUSACell",
    '338020': "Cable & Wireless",
    '338050': "DIGICEL/Mossel",
    '338110': "Cable & Wireless",
    '338180': "Cable & Wireless",
    '34001': "Orange Caribe",
    '34002': "Outremer Telecom",
    '34003': "TelCell GSM",
    '34008': "Dauphin Telecom SU (Guadeloupe Telecom)",
    '34011': "TelCell GSM",
    '34012': "UTS Caraibe",
    '34020': "Bouygues/DigiCel",
    '342050': "Digicel",
    '342299': "Ozone",
    '342600': "Flow / Lime",
    '342750': "Digicel",
    '342810': "Cingular Wireless",
    '342820': "Sunbeach",
    '34403': "imobile / APUA",
    '344030': "imobile / APUA",
    '34492': "Flow",
    '344920': "Flow",
    '34493': "Digicel",
    '344930': "Digicel",
    '346001': "Logic",
    '346006': "Digicel Ltd.",
    '346050': "Digicel",
    '346140': "Flow / Lime",
    '348170': "LIME",
    '348570': "Caribbean Cellular",
    '348770': "Digicel",
    '350000': "Bermuda Digital Communications Ltd (BDC)",
    '35001': "Digicel",
    '35002': "M3 Wireless Ltd",
    '35099': "CellOne Ltd",
    '352030': "Digicel",
    '352050': "Digicel",
    '352110': "Cable & Wireless",
    '354860': "Cable & Wireless",
    '356110': "Cable & Wireless",
    '35650': "Digicel",
    '35670': "UTS Cariglobe",
    '358110': "Cable & Wireless",
    '35830': "Cingular Wireless",
    '35850': "Digicel (St Lucia) Limited",
    '360050': "Digicel",
    '36010': "Cingular",
    '360100': "Cingular",
    '360110': "C & W",
    '36070': "Digicel",
    '36251': "TELCELL GSM",
    '362630': "Cingular Wireless",
    '36269': "Polycom N.V./ Digicel",
    '36291': "SETEL GSM",
    '36295': "EOCG Wireless NV",
    '362951': "UTS Wireless",
    '362999': "Fix Line",
    '36301': "SETAR",
    '36302': "Digicel",
    '36320': "Digicel",
    '363299': "MIO",
    '36403': "Smart Communications",
    '36430': "Cybercell / BaTelCo",
    '36439': "Cybercell / BaTelCo",
    '364390': "Cybercell / BaTelCo",
    '364490': "Aliv",
    '365840': "Flow",
    '365850': "Digicel",
    '366020': "Cingular Wireless/Digicel",
    '366050': "Wireless Ventures (Dominica) Ltd (Digicel Dominica)",
    '366110': "C & W",
    '36801': "CubaCel/C-COM",
    '368999': "Fix Line",
    '37001': "Orange",
    '37002': "Claro",
    '37003': "TRIcom",
    '37004': "Viva",
    '37201': "Comcel",
    '37202': "Digicel",
    '37203': "Natcom",
    '37412': "Bmobile/TSTT",
    '374120': "Bmobile/TSTT",
    '374130': "Digicel",
    '374140': "LaqTel Ltd.",
    '376050': "Digicel TCI Ltd",
    '376350': "Cable & Wireless (TCI) Ltd",
    '376352': "IslandCom Communications Ltd.",
    '37650': "Digicel",
    '40001': "Azercell",
    '40002': "Bakcell",
    '40003': "FONEX",
    '40004': "Nar Mobile",
    '40006': "Naxtel",
    '40101': "Beeline/KaR-Tel LLP",
    '40102': "K-Cell",
    '40107': "Dalacom/Altel",
    '40177': "Tele2/NEO/MTS",
    '40211': "B-Mobile",
    '40217': "Bhutan Telecom Ltd (BTL)",
    '40277': "TashiCell",
    '40401': "Aircel Digilink India",
    '40404': "Idea Cellular Ltd.",
    '404045': "Bharti Airtel Limited (Karnataka) (India)",
    '40405': "Fascel",
    '40407': "Idea Cellular Ltd.",
    '40409': "Reliance Telecom Private",
    '40410': "Bharti Airtel Limited (Delhi)",
    '40411': "Sterling Cellular Ltd.",
    '40412': "Escotel Mobile Communications",
    '40413': "Barakhamba Sales & Serv.",
    '40414': "Spice",
    '40415': "Aircel Digilink India",
    '40416': "Hexcom India",
    '40417': "Aircel",
    '40418': "Reliance Telecom Private",
    '40419': "Escotel Mobile Communications",
    '40422': "Idea Cellular Ltd.",
    '40424': "Idea Cellular Ltd.",
    '40425': "Aircel",
    '40428': "Aircel",
    '40429': "Aircel",
    '40430': "Usha Martin Telecom",
    '40433': "Aircel",
    '40434': "BSNL",
    '40436': "Reliance Telecom Private",
    '40438': "BSNL",
    '40441': "RPG Cellular",
    '40442': "Aircel",
    '40443': "Vodafone/Essar/Hutch",
    '40444': "Spice",
    '40450': "Reliance Telecom Private",
    '40451': "BSNL",
    '40452': "Reliance Telecom Private",
    '40453': "BSNL",
    '40454': "BSNL",
    '40455': "BSNL",
    '40456': "Escotel Mobile Communications",
    '40457': "BSNL",
    '40458': "BSNL",
    '40459': "BSNL",
    '40460': "Aircel Digilink India",
    '40462': "BSNL",
    '40464': "BSNL",
    '40466': "BSNL",
    '40467': "Reliance Telecom Private",
    '40468': "Mahanagar Telephone Nigam",
    '40469': "Mahanagar Telephone Nigam",
    '40470': "Hexacom India",
    '40471': "BSNL",
    '40472': "BSNL",
    '40473': "BSNL",
    '40474': "BSNL",
    '40475': "BSNL",
    '40476': "BSNL",
    '40477': "BSNL",
    '40478': "Idea Cellular Ltd.",
    '40479': "CellOne A&N",
    '40480': "BSNL",
    '40481': "BSNL",
    '40482': "Escorts Telecom Ltd.",
    '40483': "Reliable Internet Services",
    '40485': "Reliance Telecom Private",
    '40486': "Barakhamba Sales & Serv.",
    '40487': "Escorts Telecom Ltd.",
    '40488': "Escorts Telecom Ltd.",
    '40489': "Escorts Telecom Ltd.",
    '404998': "Fix Line",
    '404999': "Various Networks",
    '405034': "TATA / Karnataka",
    '40505': "Fascel Limited",
    '40553': "AirTel",
    '40587': "Reliance Telecom Private",
    '41001': "Jazz",
    '41003': "Ufone",
    '41004': "Zong",
    '41005': "SCOM",
    '41006': "Telenor",
    '41007': "Jazz",
    '41008': "Instaphone",
    '410299': "Warid",
    '41201': "AWCC",
    '41203': "WaselTelecom (WT)",
    '41220': "Roshan",
    '41230': "Etisalat",
    '41240': "MTN",
    '41250': "Etisalat",
    '41280': "Mobifone",
    '41288': "Mobifone",
    '41301': "Mobitel Ltd.",
    '41302': "MTN/Dialog",
    '41303': "Etisalat/Tigo",
    '41305': "Airtel",
    '41308': "H3G Hutchison",
    '41401': "Myanmar Post & Teleco.",
    '41405': "Oreedoo",
    '41406': "Telenor",
    '41409': "Mytel (Myanmar",
    '414999': "Fix Line (Myanmar",
    '41501': "MIC1 (Alfa)",
    '41503': "MIC2/LibanCell/MTC",
    '41532': "Cellis",
    '41533': "Cellis",
    '41534': "FTML Cellis",
    '41535': "Cellis",
    '41536': "MIC2/LibanCell/MTC",
    '41537': "MIC2/LibanCell/MTC",
    '41538': "MIC2/LibanCell/MTC",
    '41539': "MIC2/LibanCell/MTC",
    '41601': "Zain",
    '41602': "Xpress",
    '41603': "Umniah",
    '41677': "Orange",
    '416999': "Fix Line",
    '41701': "Syriatel Holdings",
    '41702': "MTN/Spacetel",
    '41709': "Syriatel Holdings",
    '41805': "Asia Cell",
    '41808': "Sanatel",
    '41820': "Zain",
    '41830': "Orascom Telecom",
    '41840': "Korek",
    '41845': "Mobitel",
    '41866': "Fastlink",
    '41882': "Korek",
    '41892': "Itisaluna and Kalemat",
    '41902': "Zain",
    '41903': "Ooredoo",
    '41904': "Viva",
    '419999': "Fix Line",
    '42001': "STC/Al Jawal",
    '42003': "Etihad/Etisalat/Mobily",
    '42004': "Zain",
    '42005': "Virgin Mobile",
    '42006': "Lebara Mobile",
    '42007': "Zain",
    '42101': "Sabaphone",
    '42102': "MTN/Spacetel",
    '42103': "Yemen Mob. CDMA",
    '42104': "HITS/Y Unitel",
    '421999': "Fix Line",
    '42202': "Oman Mobile/GTO",
    '42203': "Nawras",
    '42402': "Etisalat",
    '42403': "DU",
    '42501': "Orange",
    '42502': "Cellcom",
    '42503': "Pelephone",
    '42505': "Jawwal",
    '42506': "Ooredoo",
    '42507': "Hot Mobile",
    '42508': "Golan Telecom",
    '42509': "We4G",
    '42512': "Pelephone",
    '42513': "Ituran",
    '42514': "YouPhone",
    '42515': "Home Cellular",
    '42516': "Rami Levy Communications",
    '42517': "Von waves",
    '42519': "019 Mobile",
    '42522': "Maskyoo",
    '42523': "Beezz",
    '425299': "Annatel Mobile",
    '42577': "Hot Mobile",
    '42601': "Batelco",
    '42602': "Zain",
    '42604': "VIVA",
    '42605': "Royal Court",
    '426999': "Fix Line",
    '42701': "Ooredoo/Qtel",
    '42702': "Vodafone",
    '42800': "Skytel Co. Ltd",
    '42888': "Unitel",
    '42891': "Skytel Co. Ltd",
    '42898': "G-Mobile Corporation Ltd",
    '42899': "Mobicom",
    '42901': "NT Mobile / Namaste",
    '42902': "Ncell",
    '42904': "Smart Cell",
    '429999': "Fix Line",
    '43002': "Etisalat",
    '43102': "Etisalat",
    '43211': "MCI/TCI",
    '43214': "TKC/KFZO",
    '43219': "Mobile Telecommunications Company of Esfahan JV-PJS (MTCE)",
    '43220': "Rightel",
    '43232': "Taliya",
    '43235': "MTN/IranCell",
    '43270': "MTCE",
    '432999': "Fix Line",
    '43401': "Buztel",
    '43402': "Uzmacom",
    '43404': "Bee Line/Unitel",
    '43405': "Ucell/Coscom",
    '43407': "MTS/Uzdunrobita",
    '43601': "Tcell/JC Somoncom",
    '43602': "CJSC Indigo Tajikistan",
    '43603': "Megafon",
    '43604': "Babilon-M",
    '43605': "Bee Line",
    '43612': "Tcell/JC Somoncom",
    '43701': "Beeline",
    '43702': "KT Mobile",
    '43703': "Sem Mobile",
    '43705': "MegaCom",
    '43709': "O!",
    '43710': "Saima",
    '43801': "MTS/Barash Communication",
    '43802': "Altyn Asyr/TM-Cell",
    '44000': "SoftBank",
    '44001': "NTT DoCoMo",
    '44002': "NTT DoCoMo",
    '44003': "NTT DoCoMo",
    '44004': "SoftBank",
    '44005': "SoftBank",
    '44006': "SoftBank",
    '44007': "KDDI",
    '44008': "KDDI",
    '44009': "NTT DoCoMo",
    '44010': "NTT DoCoMo",
    '44011': "NTT DoCoMo",
    '44012': "NTT DoCoMo",
    '44013': "NTT DoCoMo",
    '44014': "NTT DoCoMo",
    '44015': "NTT DoCoMo",
    '44016': "NTT DoCoMo",
    '44017': "NTT DoCoMo",
    '44018': "NTT DoCoMo",
    '44019': "NTT DoCoMo",
    '44020': "SoftBank",
    '44021': "NTT DoCoMo",
    '44022': "NTT DoCoMo",
    '44023': "NTT DoCoMo",
    '44024': "NTT DoCoMo",
    '44025': "NTT DoCoMo",
    '44026': "NTT DoCoMo",
    '44027': "NTT DoCoMo",
    '44028': "NTT DoCoMo",
    '44029': "NTT DoCoMo",
    '44030': "NTT DoCoMo",
    '44031': "NTT DoCoMo",
    '44032': "NTT DoCoMo",
    '44033': "NTT DoCoMo",
    '44034': "NTT DoCoMo",
    '44035': "NTT DoCoMo",
    '44036': "NTT DoCoMo",
    '44037': "NTT DoCoMo",
    '44038': "NTT DoCoMo",
    '44039': "NTT DoCoMo",
    '44040': "SoftBank",
    '44041': "SoftBank",
    '44042': "SoftBank",
    '44043': "SoftBank",
    '44044': "SoftBank",
    '44045': "SoftBank",
    '44046': "SoftBank",
    '44047': "SoftBank",
    '44048': "SoftBank",
    '44049': "NTT DoCoMo",
    '44050': "KDDI",
    '44051': "KDDI",
    '44052': "KDDI",
    '44053': "KDDI",
    '44054': "KDDI",
    '44055': "KDDI",
    '44056': "KDDI",
    '44058': "NTT DoCoMo",
    '44060': "NTT DoCoMo",
    '44061': "NTT DoCoMo",
    '44062': "NTT DoCoMo",
    '44063': "NTT DoCoMo",
    '44064': "NTT DoCoMo",
    '44065': "NTT DoCoMo",
    '44066': "NTT DoCoMo",
    '44067': "NTT DoCoMo",
    '44068': "NTT DoCoMo",
    '44069': "NTT DoCoMo",
    '44070': "KDDI",
    '44071': "KDDI",
    '44072': "KDDI",
    '44073': "KDDI",
    '44074': "KDDI",
    '44075': "KDDI",
    '44076': "KDDI",
    '44077': "KDDI",
    '44078': "Okinawa Cellular",
    '44079': "KDDI",
    '44080': "KDDI",
    '44081': "KDDI",
    '44082': "KDDI",
    '44083': "KDDI",
    '44084': "KDDI",
    '44085': "KDDI",
    '44086': "KDDI",
    '44087': "NTT DoCoMo",
    '44088': "KDDI",
    '44089': "KDDI",
    '44090': "SoftBank",
    '44092': "SoftBank",
    '44093': "SoftBank",
    '44094': "SoftBank",
    '44095': "SoftBank",
    '44096': "SoftBank",
    '44097': "SoftBank",
    '44098': "SoftBank",
    '44099': "NTT DoCoMo",
    '44140': "NTT DoCoMo",
    '44141': "NTT DoCoMo",
    '44142': "NTT DoCoMo",
    '44143': "NTT DoCoMo",
    '44144': "NTT DoCoMo",
    '44145': "NTT DoCoMo",
    '44161': "SoftBank",
    '44162': "SoftBank",
    '44163': "SoftBank",
    '44164': "SoftBank",
    '44165': "SoftBank",
    '44170': "KDDI",
    '44190': "NTT DoCoMo",
    '44191': "NTT DoCoMo",
    '44192': "NTT DoCoMo",
    '44193': "NTT DoCoMo",
    '44194': "NTT DoCoMo",
    '44198': "NTT DoCoMo",
    '44199': "NTT DoCoMo",
    '45002': "olleh / KT",
    '45003': "SK Telecom",
    '45004': "olleh / KT",
    '45005': "SK Telecom",
    '45006': "LG U+",
    '45007': "KT Powertel",
    '45008': "olleh / KT",
    '45011': "SK Telecom",
    '45012': "SK Telecom",
    '45201': "MobiFone",
    '45202': "VinaPhone",
    '45203': "S-Fone/Telecom",
    '45204': "Viettel",
    '45205': "Vietnamobile",
    '45206': "Viettel",
    '45207': "Gmobile",
    '45208': "I-Telecom",
    '45209': "Reddi",
    '45400': "CSL Ltd.",
    '45401': "Citic Telecom Ltd.",
    '45402': "CSL Ltd.",
    '45403': "H3G/Hutchinson",
    '45404': "H3G/Hutchinson",
    '45405': "H3G/Hutchinson",
    '45406': "Vodafone/SmarTone",
    '45407': "China Unicom Ltd",
    '45408': "Truephone",
    '45409': "China Motion",
    '45410': "CSL/New World PCS Ltd.",
    '45411': "China-HongKong Telecom Ltd (CHKTL)",
    '45412': "China Mobile/Peoples",
    '45413': "China Mobile/Peoples",
    '45414': "H3G/Hutchinson",
    '45415': "Vodafone/SmarTone",
    '45416': "HKT/PCCW",
    '45417': "Vodafone/SmarTone",
    '45418': "CSL Ltd.",
    '45419': "HKT/PCCW",
    '45420': "HKT/PCCW",
    '45424': "Multibyte Info Technology Ltd",
    '45428': "China Mobile/Peoples",
    '45429': "HKT/PCCW",
    '45431': "CTExcel",
    '45440': "shared by private TETRA systems",
    '45447': "shared by private TETRA systems",
    '45500': "Smartone Mobile",
    '45501': "C.T.M. TELEMOVEL+",
    '45502': "China Telecom",
    '45503': "Hutchison Telephone Co. Ltd",
    '45504': "C.T.M. TELEMOVEL+",
    '45505': "Hutchison Telephone Co. Ltd",
    '45506': "Smartone Mobile",
    '45601': "Cellcard",
    '45602': "Smart",
    '45603': "QB/Cambodia Adv. Comms.",
    '45604': "QB",
    '45605': "Smart",
    '45606': "Smart",
    '45608': "Metfone",
    '45609': "Sotelco/Beeline",
    '45611': "Seatel",
    '45618': "Cellcard",
    '456299': "CooTel",
    '45701': "Lao Tel",
    '45702': "ETL Mobile",
    '45703': "UNITEL/LAT",
    '45708': "Beeline/Tigo/Millicom",
    '46000': "China Mobile GSM",
    '46001': "China Unicom",
    '46002': "China Mobile GSM",
    '46003': "China Telecom",
    '46004': "China Space Mobile Satellite Telecommunications Co. Ltd (China Spacecom)",
    '46005': "China Telecom",
    '46006': "China Unicom",
    '46007': "China Mobile GSM",
    '460999': "Fix Line",
    '46601': "Far EasTone",
    '46602': "Far EasTone",
    '46603': "Far EasTone",
    '46605': "Asia Pacific Telecom Co. Ltd (APT)",
    '46606': "Far EasTone",
    '46607': "Far EasTone",
    '46609': "VMAX Telecom Co. Ltd",
    '46610': "Global Mobile Corp.",
    '46611': "Chunghwa Telecom LDM",
    '46656': "International Telecom Co. Ltd (FITEL)",
    '46668': "ACeS Taiwan - ACeS Taiwan Telecommunications Co Ltd",
    '46688': "KG Telecom",
    '46689': "T-Star/VIBO",
    '46690': "T-Star/VIBO",
    '46692': "Chunghwa Telecom LDM",
    '46693': "Mobitai",
    '46697': "Taiwan Cellular",
    '46699': "TransAsia",
    '467192': "Koryolink",
    '467193': "Sun Net",
    '467299': "Kangsung Net",
    '47001': "GrameenPhone",
    '47002': "Airtel",
    '47003': "Banglalink",
    '47004': "TeleTalk",
    '47005': "Citycell",
    '47006': "Citycell",
    '47007': "Airtel",
    '47201': "Dhiraagu/C&W",
    '47202': "Ooredo/Wataniya",
    '50201': "Art900",
    '50210': "DiGi",
    '50211': "Telekom Malaysia",
    '50212': "Maxis",
    '50213': "Celcom",
    '50214': "Telekom Malaysia",
    '502150': "Tune Talk",
    '502151': "Baraka Telecom Sdn Bhd",
    '502152': "Yes",
    '502153': "Webe Digital",
    '502154': "TT dotCom",
    '502155': "Samata Communications Sdn Bhd",
    '502156': "Altel Communications",
    '50216': "DiGi",
    '50217': "Maxis",
    '50218': "U Mobile",
    '50219': "Celcom",
    '502195': "XOX Com",
    '502198': "Celcom",
    '50220': "Electcoms Wireless Sdn Bhd",
    '502299': "Maxis Broadband",
    '502999': "Fix Line",
    '50501': "Telstra",
    '50502': "Optus",
    '50503': "Vodafone",
    '50504': "Department of Defense",
    '50505': "The Ozitel Network Pty.",
    '50506': "H3G Ltd.",
    '50507': "Vodafone",
    '50508': "Railcorp/Vodafone",
    '50509': "Airnet Commercial Australia Ltd..",
    '50510': "Norfolk Telecom",
    '50511': "Telstra",
    '50512': "H3G Ltd.",
    '50513': "RailCorp",
    '50514': "AAPT Ltd.",
    '50516': "VicTrack",
    '50519': "Lycamobile",
    '50524': "Advanced Comm Tech Pty.",
    '50526': "Sinch",
    '505299': "ACMA",
    '50530': "Compatel",
    '50535': "MessageBird",
    '50539': "Telstra",
    '50550': "Pivotel",
    '50571': "Telstra",
    '50572': "Telstra",
    '50588': "Pivotel",
    '50590': "Optus",
    '50599': "Railcorp/Vodafone",
    '505999': "Fix Line",
    '51000': "PT Pasifik Satelit Nusantara (PSN)",
    '51001': "Indosat/Satelindo/M3",
    '51007': "Flexi (PT Telkom) (CDMA)",
    '51008': "Axis/Natrindo",
    '51009': "PT Smartfren Telecom Tbk",
    '51010': "Telkomsel",
    '51011': "PT. Excelcom",
    '51021': "Indosat/Satelindo/M3",
    '51027': "PT Sampoerna Telekomunikasi Indonesia (STI)",
    '51028': "PT Smartfren Telecom Tbk",
    '51089': "H3G CP",
    '51099': "Esia (PT Bakrie Telecom) (CDMA)",
    '510999': "Fix Line",
    '51401': "Telkomcel",
    '51402': "Timor Telecom",
    '51403': "Telemor",
    '514999': "Fix Line",
    '51501': "Globe Telecom",
    '51502': "Globe Telecom",
    '51503': "Smart",
    '51505': "SUN/Digitel",
    '51518': "RED Mobile/Cure",
    '51588': "Next Mobile",
    '515999': "Fix Line",
    '52000': "Hutch/CAT CDMA",
    '52001': "AIS/Advanced Info Service",
    '52003': "AIS/Advanced Info Service",
    '52004': "True Move/Orange",
    '52005': "Total Access (DTAC)",
    '52015': "ACT Mobile",
    '52018': "Total Access (DTAC)",
    '52020': "ACeS Thailand - ACeS Regional Services Co Ltd",
    '52023': "Digital Phone Co.",
    '52099': "True Move/Orange",
    '520999': "Fix Line",
    '52501': "Singtel",
    '52502': "Singtel",
    '52503': "MobileOne Ltd",
    '52505': "Starhub",
    '52506': "Starhub",
    '52507': "Singtel",
    '52512': "GRID Communications Pte Ltd",
    '525999': "Fix Line",
    '52801': "Telekom Brunei Bhd (TelBru)",
    '52802': "b-mobile",
    '52811': "Datastream (DTSCom)",
    '53001': "Vodafone",
    '53002': "Spark Mobile",
    '53003': "Walker Wireless Ltd.",
    '53004': "Telstra",
    '53005': "Spark Mobile",
    '53024': "2degrees",
    '53028': "2degrees",
    '530999': "Fix Line",
    '53701': "Pacific Mobile",
    '53702': "GreenCom PNG Ltd",
    '53703': "Digicel",
    '537999': "Fix Line",
    '53901': "Tonga Communications",
    '53943': "Shoreline Communication",
    '53988': "Digicel",
    '539999': "Fix Line",
    '54001': "BREEZE",
    '54002': "bemobile",
    '54010': "BREEZE",
    '54101': "SMILE",
    '54105': "DigiCel",
    '54201': "Vodafone",
    '54202': "DigiCell",
    '54301': "Manuia",
    '54411': "BlueSky",
    '544780': "ASTCA Mobile",
    '54509': "Kiribati Frigate",
    '54601': "OPT Mobilis",
    '54715': "Pacific Mobile Telecom (PMT)",
    '54720': "Vini/Tikiphone",
    '54801': "Vodafone / Bluesky",
    '54901': "Telecom Samoa Cellular Ltd.",
    '54927': "Samoatel Mobile",
    '549999': "Fix Line",
    '55001': "FSM Telecommunications Corp.",
    '551299': "MINTA",
    '55201': "Palau National Communications Corp. (PNCC) (Palau",
    '55202': "PECI/PalauTel (Palau",
    '55280': "Palau Mobile Corp. (PMC) (Palau",
    '55301': "Tuvalu Telecommunication Corporation (TTC)",
    '55501': "Niue Telecom",
    '60201': "Orange",
    '60202': "Vodafone",
    '60203': "Etisalat",
    '60204': "WE",
    '60301': "Mobilis",
    '60302': "Djezzy",
    '60303': "Ooredoo",
    '60400': "Orange",
    '60401': "IAM",
    '60402': "inwi",
    '60404': "Al Houria Telecom",
    '60405': "inwi",
    '60406': "IAM",
    '60499': "Al Houria Telecom",
    '60501': "Orange",
    '60502': "TT Mobile",
    '60503': "Ooredoo",
    '60506': "Lycamobile",
    '605999': "Fix Line",
    '60600': "Libyana",
    '60601': "Al-Madar",
    '60602': "Al-Madar",
    '60603': "LibyaPhone Mobile",
    '60606': "Hatef",
    '60701': "Gamcel",
    '60702': "Africel",
    '60703': "Comium",
    '60704': "QCell",
    '60801': "Orange",
    '60802': "Free",
    '60803': "Expresso",
    '60804': "HAYO",
    '608299': "2s Mobile",
    '60901': "Mattel",
    '60902': "Chinguitel",
    '60910': "Mauritel",
    '61001': "Malitel",
    '61002': "Orange",
    '61003': "Telecel",
    '61101': "Orange",
    '61102': "SotelGui",
    '61103': "Intercel",
    '61104': "MTN",
    '61105': "Cellcom",
    '61201': "Comstar",
    '61202': "Moov",
    '61203': "Orange",
    '61204': "Comium",
    '61205': "MTN",
    '61206': "OriCell",
    '61207': "Aircomm SA",
    '61301': "Telmob",
    '61302': "Orange",
    '61303': "Telecel",
    '61401': "Niger Telecoms",
    '61402': "Airtel",
    '61403': "Moov",
    '61404': "Orange",
    '61501': "Togo Cellulaire / TogoCel",
    '61502': "Telecel/MOOV",
    '61503': "Atlantique Telecom / Moov",
    '61601': "Libercom",
    '61602': "Moov",
    '61603': "MTN",
    '61604': "Bell Benin/BBCOM",
    '61605': "GloMobile",
    '61701': "my.t mobile",
    '61702': "Chili",
    '61703': "Chili",
    '61710': "Emtel",
    '61801': "MTN / Lonestar",
    '61802': "Libercell",
    '61804': "Novafone",
    '61807': "Orange",
    '61820': "LibTelco",
    '61901': "Orange",
    '61902': "Tigo/Millicom",
    '61903': "Africell",
    '61904': "Comium",
    '61905': "Africell",
    '61907': "Qcell",
    '61925': "Mobitel",
    '619299': "IPTel",
    '62001': "MTN",
    '62002': "Vodafone",
    '62003': "Airtel",
    '62004': "Expresso Ghana Ltd",
    '62005': "National Security",
    '62006': "Airtel",
    '62007': "Glo",
    '62008': "Surfline",
    '620299': "Comsys",
    '62101': "Visafone",
    '62120': "Airtel",
    '62125': "Visafone",
    '62127': "Smile",
    '621299': "Alpha Technologies",
    '62130': "MTN",
    '62140': "ntel",
    '62150': "Glo Mobile",
    '62160': "9mobile",
    '62199': "Starcomms",
    '62201': "Airtel",
    '62202': "Tchad Mobile",
    '62203': "Moov",
    '62204': "Salam",
    '62301': "Moov",
    '62302': "Telecel",
    '62303': "Orange",
    '62304': "Azur",
    '623299': "Socatel",
    '62401': "MTN",
    '62402': "Orange",
    '62404': "Nexttel",
    '62501': "CVMovel",
    '62502': "Unitel T+",
    '62601': "CSTmovel",
    '62602': "Unitel",
    '62701': "Orange",
    '62703': "Muni",
    '62801': "Libertis",
    '62802': "MOOV/Telecel",
    '62803': "Airtel",
    '62804': "Azur/Usan S.A.",
    '62901': "Airtel",
    '62902': "Azur SA (ETC)",
    '62907': "Warid",
    '62910': "MTN",
    '63001': "Vodacom",
    '63002': "Airtel",
    '63005': "Supercell",
    '630299': "Tatem",
    '63086': "Orange",
    '63088': "Yozma Timeturns",
    '63089': "TIGO/Oasis",
    '63090': "Africell",
    '63102': "Unitel",
    '63104': "MoviCel",
    '63201': "Guinetel",
    '63202': "MTN",
    '63203': "Orange",
    '632999': "Fix\tLine",
    '63301': "Cable & Wireless",
    '63302': "Smartcom",
    '63305': "Intelvision",
    '63310': "Airtel",
    '63400': "Canar Telecom",
    '63401': "Zain",
    '63402': "MTN",
    '63403': "MTN",
    '63405': "Canar Telecom",
    '63406': "Zain",
    '63407': "Sudani One",
    '63408': "Canar Telecom",
    '63415': "Sudani One",
    '63422': "MTN",
    '634999': "Fix Line",
    '63510': "MTN",
    '63513': "Airtel",
    '63514': "Airtel",
    '63601': "Ethio Mobile",
    '63701': "Telesom",
    '63704': "Somafone",
    '63710': "Nationlink",
    '63719': "Hormuud",
    '637299': "AirSom",
    '63730': "Golis",
    '63750': "Hormuud",
    '63760': "Nationlink",
    '63770': "Onkod",
    '63771': "Somtel",
    '63782': "Telcom Mobile",
    '63801': "Evatis",
    '63901': "Safaricom",
    '63902': "Safaricom",
    '63903': "Airtel",
    '63904': "Mobile Pay",
    '63905': "Airtel",
    '63906': "Finserve Africa",
    '63907': "Telkom",
    '63909': "Homeland Media",
    '63910': "Jamii Telecommunications",
    '63911': "Jambo Telcoms",
    '63912': "Infura",
    '639299': "eferio",
    '64001': "Tri Telecomm. Ltd.",
    '64002': "Tigo / MIC",
    '64003': "Zanzibar Telecom / Zantel",
    '64004': "Vodacom",
    '64005': "Airtel",
    '64006': "Dovetel (T) Ltd",
    '64007': "Tanzania Telecommunication Corporation",
    '64008': "Benson Informatics Ltd",
    '64009': "Halotel / Viettel",
    '64011': "Smile Communications",
    '64013': "WiAfrica",
    '64014': "MO Mobile",
    '64099': "Mkulima African Telecommunication",
    '64101': "Airtel",
    '64104': "Lycamobile",
    '64110': "MTN",
    '64111': "Mango",
    '64114': "Orange",
    '64118': "Suretelecom Uganda Ltd",
    '64122': "Airtel",
    '64130': "K2 Telecom Ltd",
    '64133': "Smile",
    '64166': "i-Tel Ltd",
    '641999': "Fix Line",
    '64201': "Leo",
    '64202': "Africel / Safaris",
    '64203': "ONAMOB",
    '64207': "Smart",
    '64208': "Lumitel",
    '64282': "Leo",
    '642999': "Fix\tLine",
    '64301': "TMCEL",
    '64303': "Movitel",
    '64304': "Vodacom",
    '64501': "Airtel",
    '64502': "MTN",
    '64503': "Zamtel",
    '64601': "Airtel",
    '64602': "Orange",
    '64603': "Sacel",
    '64604': "Telma",
    '646299': "Bip",
    '64700': "Orange",
    '64701': "Maore Mobile",
    '64702': "Only",
    '64703': "Only",
    '64704': "ZEOP Mobile",
    '64710': "SFR",
    '64801': "NetOne",
    '64803': "Telecel",
    '64804': "Econet",
    '64901': "MTC",
    '64902': "Switch/Nam. Telec.",
    '64903': "TN Mobile",
    '649299': "Demshi",
    '65001': "TNM",
    '65010': "Airtel",
    '65101': "Vodacom",
    '65102': "Econet",
    '65201': "Mascom",
    '65202': "Orange",
    '65204': "beMobile",
    '65301': "EswatiniTelecom",
    '65302': "Eswatini Mobile",
    '65310': "Swazi MTN",
    '65401': "HURI",
    '65402': "Telma",
    '65501': "Vodacom",
    '65502': "Telkom",
    '65505': "Telkom",
    '65506': "Sentech",
    '65507': "Cell C",
    '65510': "MTN",
    '65512': "MTN",
    '65519': "Rain",
    '65521': "Cape Town Metropolitan",
    '655299': "Lycamobile",
    '65538': "Rain",
    '65573': "Rain",
    '65574': "Rain",
    '65701': "Eritel",
    '65902': "MTN",
    '65903': "Gemtel Ltd (South Sudan",
    '65904': "Network of The World Ltd (NOW) (South Sudan",
    '65906': "Zain",
    '659299': "Digitel",
    '702099': "Smart",
    '70267': "DigiCell",
    '70268': "International Telco (INTELCO)",
    '70269': "Smart",
    '70401': "Claro",
    '70402': "TIGO/COMCEL",
    '70403': "Telefonica",
    '70601': "CLARO/CTE",
    '70602': "Digicel",
    '70603': "Telemovil",
    '70604': "Telefonica",
    '70605': "INTELFON SA de CV",
    '708001': "SERCOM/CLARO",
    '708002': "Telefonica/CELTEL",
    '708030': "HonduTel",
    '708040': "Digicel",
    '71021': "Empresa Nicaraguense de Telecomunicaciones SA (ENITEL)",
    '71030': "Movistar",
    '71073': "Claro",
    '710999': "Fix Line",
    '71201': "ICE",
    '71202': "ICE",
    '71203': "Claro",
    '71204': "Movistar",
    '71220': "Virtualis",
    '712999': "Fix Line",
    '71401': "Cable & W./Mas Movil",
    '71402': "Movistar",
    '714020': "Movistar",
    '71403': "Claro",
    '71404': "Digicel",
    '714999': "Fix Line",
    '71601': "GlobalStar",
    '71602': "GlobalStar",
    '71606': "Movistar",
    '71607': "Nextel",
    '71610': "Claro /Amer.Mov./TIM",
    '71615': "Viettel Mobile",
    '71617': "Nextel",
    '71620': "Claro /Amer.Mov./TIM",
    '722007': "Movistar",
    '722010': "Movistar",
    '722020': "Nextel",
    '722031': "Claro",
    '722034': "Personal",
    '722070': "Movistar",
    '722299': "Express",
    '722310': "Claro",
    '722320': "Claro",
    '722330': "Claro",
    '722340': "Personal",
    '722341': "Personal",
    '722999': "Fix Line",
    '72400': "Nextel (Telet)",
    '72401': "Vivo S.A./Telemig",
    '72402': "TIM",
    '72403': "TIM",
    '72404': "TIM",
    '72405': "Claro/Albra/America Movil",
    '72406': "Vivo S.A./Telemig",
    '72407': "CTBC/Triangulo",
    '72408': "TIM",
    '72410': "Vivo S.A./Telemig",
    '72411': "Vivo S.A./Telemig",
    '72412': "Claro/Albra/America Movil",
    '72415': "Sercontel Cel",
    '72416': "Brazil Telcom",
    '72419': "Vivo S.A./Telemig",
    '72423': "Vivo S.A./Telemig",
    '72424': "Amazonia Celular S/A",
    '72426': "AmericaNet",
    '72430': "Oi (TNL PCS / Oi)",
    '72431': "Oi (TNL PCS / Oi)",
    '72432': "CTBC Celular SA (CTBC)",
    '72433': "CTBC Celular SA (CTBC)",
    '72434': "CTBC Celular SA (CTBC)",
    '72437': "Unicel do Brasil Telecomunicacoes Ltda",
    '72438': "Claro/Albra/America Movil",
    '72439': "Nextel (Telet)",
    '72454': "PORTO SEGURO TELECOMUNICACOES",
    '73000': "TESAM SA",
    '73001': "Entel Telefonia Mov",
    '73002': "TELEFONICA",
    '73003': "Claro",
    '73004': "Nextel SA",
    '73005': "Nextel SA",
    '73006': "Blue Two Chile SA",
    '73007': "TELEFONICA",
    '73008': "VTR Banda Ancha SA",
    '73009': "Nextel SA",
    '73010': "Entel Telefonia",
    '73011': "Celupago SA",
    '73012': "Telestar Movil SA",
    '73013': "Tribe Mobile SPA",
    '73014': "Netline Telefonica Movil Ltda",
    '73015': "Cibeles Telecom SA",
    '73019': "Sociedad Falabella Movil SPA",
    '732001': "Movistar",
    '732002': "Edatel",
    '732020': "UNE",
    '732101': "Claro",
    '732102': "Movistar",
    '732103': "Tigo",
    '732111': "Tigo",
    '732123': "Movistar",
    '732130': "Avantel",
    '732142': "UNE",
    '732154': "Virgin Mobile",
    '732165': "Tigo",
    '732187': "eTb",
    '732199': "SUMA movil",
    '732220': "Libre Tecnologias",
    '732230': "Setroc Mobile",
    '732240': "Flash Mobile",
    '732299': "ATnet",
    '732360': "WOM",
    '732666': "Claro",
    '732999': "Fix Line",
    '73401': "DigiTel C.A.",
    '73402': "DigiTel C.A.",
    '73403': "DigiTel C.A.",
    '73404': "Movistar/TelCel",
    '73406': "Movilnet C.A.",
    '73601': "Viva/Nuevatel",
    '73602': "Entel Pcs",
    '73603': "Tigo",
    '73801': "DigiCel",
    '73802': "Cellink Plus",
    '74000': "MOVISTAR/OteCel",
    '740000': "Failed Call(s)",
    '74001': "Claro/Port",
    '74002': "CNT Mobile",
    '74003': "Tuenti",
    '74401': "Hola/VOX",
    '74402': "Claro/Hutchison",
    '74403': "Compa",
    '74404': "Tigo/Telecel",
    '74405': "TIM/Nucleo/Personal",
    '74601': "Telesur",
    '74602': "Telecommunicatiebedrijf Suriname (TELESUR)",
    '74603': "Digicel",
    '74604': "UNIQA",
    '746999': "Fix Line",
    '74800': "Ancel/Antel",
    '74801': "Ancel/Antel",
    '74803': "Ancel/Antel",
    '74807': "MOVISTAR",
    '74810': "Claro/AM Wireless",
    '750001': "Sure",
    '90105': "Thuraya Satellite",
    '90111': "InMarSAT",
    '90112': "Maritime Communications Partner AS",
    '90113': "Antarctica",
    '90114': "AeroMobile",
};
